<template>
    <site-img
        class="md-team single-column-block-intro"
        type="bgImg"
        :src="bgType === 'img' ? useBgSrc : ''"
        :style="{
            backgroundColor: bgType === 'color' ? bgColor : '',
            paddingTop,
            marginBottom
        }"
        v-if="allTotal > 0"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :containerStyle="containerStyle"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
        >
            <div class="mg-title" v-if="fmtTitle" v-html="formatFontSize(fmtTitle, '--mg-title-size')"></div>
            <div v-for="(agent, index) in agents" class="agent" :key="agent.id">
                <a
                    class="img-container"
                    :target="detailUrlTarget"
                    :href="useExternalUrl ? agent.externalUrl || agent.detailUrl : agent.detailUrl"
                    :style="index === 0 ? imageStyle || {} : {}"
                    rel="noopener noreferrer"
                    :aria-label="agentAlt(agent)"
                >
                    <AgentHeadShot class="image md-team-single-column-block-intro" :agent="agent" />
                </a>
                <div class="info">
                    <div
                        v-if="agent.fullName"
                        class="agent-name"
                        :class="{ name: !agent.position }"
                    >
                        <a
                            :href="agent.detailUrl"
                            :target="detailUrlTarget"
                            rel="noopener noreferrer"
                            :aria-label="agent.fullName"
                        >{{ agent.fullName }}</a>
                    </div>
                    <div v-if="agent.position" class="agent-position">
                        {{ agent.position }}
                    </div>
                </div>
                <div
                    v-if="agent.license || licenseName || company.name"
                    class="license-company"
                >
                    <p
                        v-if="agent.license || agent.licenseWithState"
                        class="text"
                    >
                        <span class="col">{{ licenseName }}</span>{{ agent.licenseWithState || agent.license }}
                    </p>
                    <p v-if="agent.phone && isMobile" class="phone">
                        <a
                            :href="'tel:' + agent.phone"
                            target="_top"
                            rel="noopener noreferrer"
                        >
                            <span ref="phone" class="text">
                                <span class="col">{{ $t('md-team.tel') }}</span>
                                {{ $ft.formatPhone(agent.phone) }}
                            </span>
                        </a>
                    </p>
                    <p v-if="agent.email && isMobile" class="email">
                        <a
                            :href="'mailto:' + agent.email"
                            target="_top"
                            :title="$t('common:link.mailtoTitle')"
                            :aria-label="
                                $t('common:link.mailtoAriaLabel', {
                                    email: agent.email
                                })
                            "
                            rel="noopener noreferrer"
                        >
                            <span class="text">
                                <span class="col">{{
                                    $t('md-team.email')
                                }}</span>
                                {{ agent.email }}
                            </span>
                        </a>
                    </p>
                    <p v-if="company.name" class="company">
                        <span class="col">{{ $t('md-team.company') }}</span>
                        {{ company.name }}
                    </p>
                    <p v-if="agent.externalUrl" class="company">
                        <span class="col">{{ $t('md-team.site') }}</span>
                        <a :href="agent.externalUrl">{{ agent.externalUrl }}</a>
                    </p>
                </div>
                <div class="information">
                    <p v-if="agent.address" class="address">
                        <a
                            :href="
                                'https://www.google.com.my/maps/search/' +
                                    agent.address
                            "
                            rel="noopener noreferrer"
                        >
                            <span class="text">
                                <span class="col">{{
                                    $t('md-team.address')
                                }}</span>
                                {{ agent.address }}
                            </span>
                        </a>
                    </p>
                    <p v-if="agent.phone && !isMobile" class="phone">
                        <a
                            :href="'tel:' + agent.phone"
                            target="_top"
                            rel="noopener noreferrer"
                        >
                            <span ref="phone" class="text">
                                <span class="col">{{ $t('md-team.tel') }}</span>
                                {{ $ft.formatPhone(agent.phone) }}
                            </span>
                        </a>
                    </p>
                    <p v-if="agent.email && !isMobile" class="email">
                        <a
                            :href="'mailto:' + agent.email"
                            target="_top"
                            :title="$t('common:link.mailtoTitle')"
                            :aria-label="
                                $t('common:link.mailtoAriaLabel', {
                                    email: agent.email
                                })
                            "
                            rel="noopener noreferrer"
                        >
                            <span class="text">
                                <span class="col">{{
                                    $t('md-team.email')
                                }}</span>
                                {{ agent.email }}
                            </span>
                        </a>
                    </p>
                </div>
                <div
                    class="single-intro"
                    v-if="agent.longIntroduction"
                    v-html="agent.longIntroduction"
                ></div>
            </div>
            <pagination
                v-if="total > 1"
                :totalPage="total"
                @pageChange="pageChange"
                :pageSize="pageSize"
                :noScroll="true"
                :pageNum="pageNum"
            />
        </module-box>
    </site-img>
</template>

<script>
import common from '../index.js';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';

import { normal } from '../../defaultSpacing';
export default {
    mixins: [common],
    data: function() {
        return {
            imageStyle: {},
            containerStyle: {},
            ...normal
        };
    },
    computed: {
        ...mapState(usePageStore, {
            company: store => store.companyInfo
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) + 'px'
            );
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) + 'px'
            );
        }
    },
    methods: {
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.single-column-block-intro {
    .module-content {
        overflow: auto;
    }
    .agent {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;
        &:last-of-type {
            margin-bottom: 0;
        }
        .img-container {
            width: 215px;
            height: 215px;
            margin-bottom: 20px;
            .image {
                width: auto;
                height: 100%;
                background: #fff;
            }
        }
        .info {
            display: flex;
            justify-content: center;
            margin-bottom: 5px;
            width: 100%;
            align-items: center;
            .agent-name {
                font-size: 28px;
                font-weight: bold;
                line-height: 1.29;
                color: #000;
                margin-right: 10px;
            }
            .agent-position {
                border-radius: 4px;
                line-height: 1.67;
                color: #191919;
                background-color: #EBECF1;
                font-size: 12px;
                text-align: center;
                padding: 2px 6px;
            }
        }
        .license-company {
            font-size: 14px;
            display: flex;
            width: 100%;
            line-height: 1.43;
            margin-bottom: 4px;
            align-items: center;
            justify-content: center;
            color: #787878;
            @include media-min-800 {
                p + p::before {
                    content: '|';
                    color: #999;
                    margin: 0 10px;
                    opacity: 0.34;
                }
            }
            // .split {
            //     display: inline-block;
            //     width: 24px;
            //     text-align: center;
            //     opacity: 0.34;
            //     color: #999;
            // }
        }
        .information {
            display: flex;
            width: 100%;
            font-size: 14px;
            line-height: 1.43;
            justify-content: center;
            align-items: center;
            color: #787878;
            @include media-min-800 {
                p + p::before {
                    content: '|';
                    color: #999;
                    margin: 0 10px;
                    opacity: 0.34;
                }
            }
        }
        .single-intro {
            margin-top: 20px;
            font-size: 14px;
            line-height: 1.5;
            color: #787878;
            text-align: left;
        }
        @include media-800 {
            position: relative;
            .img-container {
                margin-bottom: 10px;
            }
            .info {
                line-height: 1.8;
                height: 36px;
                .agent-name {
                    font-size: 20px;
                    max-width: 40%;
                    @include ellipsis();
                }
                .agent-name.name {
                    max-width: 100%;
                    text-align: center;
                }
                .agent-position {
                    max-width: 40%;
                    @include ellipsis();
                }
            }
            .license-company {
                p {
                    padding: 2px 0;
                    height: 20px;
                    line-height: 1.43;
                    text-align: center;
                    margin-top: 2px;
                }
                .text {
                    margin-top: 5px;
                }
            }
            .information {
                flex-direction: column;
                p {
                    padding: 2px 0;
                    height: 20px;
                    line-height: 1.43;
                    text-align: center;
                    margin-top: 2px;
                }
                .split {
                    display: none;
                }
            }
            .license-company {
                flex-direction: column;
                margin-bottom: 0;
                .split {
                    display: none;
                }
            }
            .single-intro {
                padding-top: 20px;
            }
        }
    }
    .comp-pagination {
        margin-bottom: 20px;
    }
}
</style>
